import { makeStyles } from '@mui/styles';
const icon = {
    width: '56px',
    height: '56px',
    display: 'inline-block',
    verticalAlign: 'middle',
};
export const useStyles = makeStyles(() => ({
    archiveIcon: {
        background: 'url(/assets/archive-icon.png) center center no-repeat',
        ...icon,
    },
    docxIcon: {
        background: 'url(/assets/docs.png) no-repeat',
        backgroundPosition: 'center -155px',
        ...icon,
    },
    pdfIcon: {
        background: 'url(/assets/docs.png) no-repeat',
        backgroundPosition: 'center -75px',
        ...icon,
    },
    xlsIcon: {
        background: 'url(/assets/docs.png) no-repeat',
        backgroundPosition: 'center -235px',
        ...icon,
    },
    pptIcon: {
        background: 'url(/assets/docs.png) no-repeat',
        backgroundPosition: 'center -315px',
        ...icon,
    },
}));
